// extracted by mini-css-extract-plugin
export default {"mainGrid":"CurrentInvestedValue_mainGrid__S4s6h","switchButtonGrid":"CurrentInvestedValue_switchButtonGrid__La2sl"};